<script setup lang="ts">
import { watchEffect, ref } from "vue";
import { getEmSize } from "@zyzgroup/core-web";

// for merge ce shadow-root styles
defineOptions({
  customOptions: {},
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    plate: string; // 无牌车
    plateType?:
      | "蓝牌"
      | "b"
      | "绿牌"
      | "g"
      | "黄牌"
      | "y"
      | "黄绿"
      | "q"
      | "黑牌"
      | "d"
      | "白牌"
      | "w"
      | "未知";
    displayType?: "dot" | "chinese" | "plaintext";
    // fontSize : 1em
  }>(),
  { displayType: "chinese" }
);

const emits = defineEmits<{
  // (event: "void"): void;
}>();

const PLATE_TYPES: { name: string; style: Record<string, string> }[] = [
  {
    name: "蓝牌",
    style: {
      "background-color": "#0078f0",
      color: "#ffffff"
    }
  },
  {
    name: "绿牌",
    style: {
      "background-color": "#00f08c",
      color: "#000000"
    }
  },
  {
    name: "黄牌",
    style: {
      "background-color": "#fac800",
      color: "#000000"
    }
  },
  {
    name: "黄绿",
    style: {
      background: "linear-gradient(90deg, #fac800 51.5%, #00f08c 51.51%)",
      color: "#000000"
    }
  },
  {
    name: "黑牌",
    style: {
      "background-color": "#222222",
      color: "#ffffff"
    }
  },
  {
    name: "白牌",
    style: {
      "background-color": "#ffffff",
      color: "#000000",
      border: "1px solid #999999"
    }
  },
  {
    name: "未知",
    style: {
      "background-color": "#cccccc",
      color: "#ffffff"
    }
  }
];

function getPlateType(name: string): {
  name: string;
  style: Record<string, string>;
} {
  switch (name) {
    case "b":
    case "蓝牌":
      name = "蓝牌";
      break;
    case "g":
    case "绿牌":
      name = "绿牌";
      break;
    case "y":
    case "黄牌":
      name = "黄牌";
      break;
    case "q":
    case "黄绿":
      name = "黄绿";
      break;
    case "d":
    case "黑牌":
      name = "黑牌";
      break;
    case "w":
    case "白牌":
      name = "白牌";
      break;
    default:
      name = "未知";
      break;
  }
  const result = PLATE_TYPES.filter((item) => item.name === name);
  return result.length ? result[0] : getPlateType("未知");
}

const plateType = ref(getPlateType(props.plateType || ""));

const el = ref();

const dotSize = ref(14);
watchEffect(() => {
  if (!el.value) {
    return;
  }
  dotSize.value = getEmSize(el.value);
});

defineExpose({});
</script>

<template>
  <div
    class="plate-display"
    ref="el"
  >
    <div
      v-if="displayType == 'dot' && plate !== '无牌车'"
      class="leading"
      :class="displayType"
      :style="{
        ...plateType.style,
        width: dotSize + 'px',
        height: dotSize + 'px',
        marginRight: 0.36 * dotSize + 'px'
      }"
    >
      {{ plateType.name }}
    </div>
    <div
      v-if="displayType == 'chinese' && plate !== '无牌车'"
      class="leading"
      :class="displayType"
      :style="plateType.style"
    >
      {{ plateType.name }}
    </div>
    <div
      v-if="displayType == 'plaintext' && plate !== '无牌车'"
      class="leading"
      :class="displayType"
    >
      {{ plateType.name }}
    </div>
    <div class="text">
      {{ plate }}
    </div>
  </div>
</template>

<style scoped>
.plate-display {
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
.leading {
  box-sizing: border-box;
  font-size: 0.86em;
  line-height: 1;
  border-radius: 0.3em;
  margin-right: 0.36em;
}
.leading.chinese {
  padding: 0.3em;
}
.leading.dot {
  font-size: 0;
  border-radius: 50%;
}
.leading.plaintext {
  padding-right: 0.36em;
  border-right: 1px solid #e6e6e6;
  border-radius: 0;
}
.text {
  line-height: 1;
}
</style>
